module.exports = __webpack_public_path__ + "static/media/hashtag-nft-4.4ae366c1.jpg";